import { State, UserIds } from '../../../types/feed';

export const initialState: State = {
  stream: undefined,
  client: undefined,
  [UserIds.Eric]: undefined,
  [UserIds.Jule]: undefined,
  [UserIds.Jessica]: undefined,
  serverSideToken: undefined,
  feedback: undefined,
};
